import { Injectable, inject, Signal } from '@angular/core';
import { AuthState } from '../../states/auth.state';

/**
 * Get User Full Name Use Case
 *
 * Retrieves the full name of the currently authenticated user.
 * Returns a computed signal that combines firstName and lastName.
 *
 * Use this when you need:
 * - Display name for UI (e.g., "John Doe")
 * - Author name for created records
 * - User attribution in logs or audit trails
 *
 * @returns Signal containing the user's full name or empty string if not authenticated
 */
@Injectable({ providedIn: 'root' })
export class GetUserFullNameUseCase {
  private readonly _authState = inject(AuthState);

  /**
   * Execute the use case
   * @returns Signal with user full name (firstName + lastName) or empty string
   */
  public execute(): Signal<string> {
    return this._authState.userFullName;
  }
}
